import * as Yup from 'yup';

export const DeleteAccountFormRecordSchema = Yup.object()
                                                .shape({
                                                           confirmation: Yup.string()
                                                                            .required('Required'),
                                                       });
